import '../main.css'
import '../../App.css'
import { useEffect, useState } from 'react'

function FallbackImage({
    src,
    alt = '',
    className = '',
    style = {},
    fallbackSrc = '/newImg/preparing.png',
    ...rest
}) {
    const [imgSrc, setImgSrc] = useState(src == null ? fallbackSrc : src);

    const handleError = () => {
        if (imgSrc !== fallbackSrc) {
            setImgSrc(fallbackSrc);
        }
    };

    return (
        <img
            src={imgSrc}
            alt={alt}
            className={className}
            style={style}
            onError={handleError}
            {...rest}
        />
    );
}

export default FallbackImage;